import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

function PackagingPage() {
  const packagingOptions = [
    {
      title: "Bulk Export Packaging",
      subtitle: "25 kg Kraft Paper Bag",
      features: [
        "Suitable for bulk import and manufacturing use",
        "Inner lining options available (on request)"
      ]
    },
    {
      title: "Retail Packaging (Small Packs)",
      subtitle: "100g Matte Pouch",
      features: [
        "Perfect for retail and online selling",
        "Custom labeling available"
      ]
    },
    {
      title: "Retail Packaging (Value Pack)",
      subtitle: "250g Matte Pouch",
      features: [
        "Great for retail shelves and distributors",
        "Custom labeling available"
      ]
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Packaging Options</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>We offer export-friendly packaging to ensure product safety during storage and international shipping. Packaging can be customized based on buyer requirement and regulations.</p>
      </div>

      <div className="packaging-grid">
        {packagingOptions.map((pkg, index) => (
          <div key={index} className="packaging-card">
            <h3>{pkg.title}</h3>
            <div className="package-highlight">{pkg.subtitle}</div>
            <ul>
              {pkg.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="page-note">
        <p>Export carton packing and palletization support available on request.</p>
      </div>

      <div className="page-cta-section">
        <h3>Need private label packaging for your brand?</h3>
        <div className="cta-buttons">
          <Link to="/request-quote" className="btn-primary">Request a Quote</Link>
        </div>
      </div>
    </div>
  );
}

export default PackagingPage;
